import MembOtpRegChkApi from "Apis/MembOtpRegChkApi";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";



const MembOtpRegChkInqUi = ({langData}:any) => {
    const [otpRegYn,setotpRegYn] = useState<any>();
    // Redux selector로 실시간 감지
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    useEffect(()=>{
        MembOtpRegChkApi()
        .then((resp) => {
            setotpRegYn(resp.apiBody);
        })
    
    },[]);
    return(
        <div className="myPageCard">
            <h2>My Security</h2>
            <div className="myPageCardCtxt">
                <ul>
                    <li className="myPageCardCtxtLi">
                        <div className="ctxtLiTitl">
                           
                            {/* otp 사용 여부 */}
                            {otpRegYn&&otpRegYn.otpUseYn =="Y"?
                                <>
                                    <p className="activeText">{langData&&langData.MYPAGE_OTP_UNREG_PAGE_TITL_00}</p>
                                </>
                                // otp 사용중
                                :
                                <p className="passiveText">{langData&&langData.MYPAGE_OTP_UNREG_PAGE_TITL_01}</p>
                                // MYPAGE_OTP_UNREG_PAGE_TITL_01 otp미사용
                            }
                            <p>{otpRegYn&&otpRegYn.otpUpdtDtime}</p>
                        </div>
                    </li>
                    {   idntMthdCd&&idntMthdCd === "NA"?
                        <li className="myPageCardCtxtLi">
                            <div className="myPageCardCtxtLiTRight">
                                <Link to={"/MyPage/IdntMthdChng"} className="moNone">
                                    {langData&&langData.MYPAGE_MAIN_OTP_REG_BTN_00}
                                    {/* otp 가입하기 */}
                                </Link>
                            </div>
                        </li>                    
                     :
                     <li className="myPageCardCtxtLi">
                        <div className="myPageCardCtxtLiTRight">
                            {otpRegYn&&otpRegYn.otpUseYn =="Y"?
                                <Link to={"/Mypage/OtpReg"} className="moNone">
                                    {langData&&langData.MYPAGE_MAIN_OTP_UNREG_BTN_00}
                                    {/* otp 해지하기 */}
                                </Link>
                                :
                                <Link to={"/Mypage/OtpReg"} className="moNone">
                                    {langData&&langData.MYPAGE_MAIN_OTP_REG_BTN_00}
                                    {/* otp 가입하기 */}
                                </Link>
                            }
                        </div>
                    </li>   
                    }
                </ul>
            </div>
        </div>
    )
}

export default MembOtpRegChkInqUi;